import React, { useEffect } from "react"
import '../NotFound.css'

const NotFound = () => {

    useEffect(() => {
        // Al montar: agregar clase al body
        document.body.classList.add('NFbody');

        // Al desmontar: limpiar clase del body
        return () => {
            document.body.classList.remove('NFbody');
        }
    }, []);

    return (
        <div className="NFcontainer">
            <h1>¡Ups!</h1>
            <p>Esta página no está disponible o no existe.</p>
            <a href="/evaluation-system">Volver al inicio</a>
        </div>
    )
}

export default NotFound
